import { ActivityServicePath, FOREIGN_LANGUAGES } from "utils/constants";
import ListActivityForeignLanguages from "./List";
import permissions from "app/permissions";
import LanguageIcon from "@mui/icons-material/Language";
import CreateActivityForeignLanguages from "./Create";
import EditActivityForeignLanguages from "./Edit";
import ShowActivityForeignLanguages from "./Show";
import { tenants } from "utils/tenants";

export const resources = {
  tenancies: [tenants.MGU],
  isMenu: true,
  icon: <LanguageIcon />,
  name: ActivityServicePath + FOREIGN_LANGUAGES,
  title: "Чужди езици",
  list: <ListActivityForeignLanguages />,
  create: <CreateActivityForeignLanguages />,
  edit: <EditActivityForeignLanguages />,
  show: <ShowActivityForeignLanguages />,
  permission: permissions.canPreviewActivitiesForeignLanguages,
};
